import { Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { OrcamentoCotacaoItem } from "features/orcamento/typings";
import { formatMoney } from "infra/helpers/number";
import { getUnidadeMedida } from "../../../../../DadosOrcamento/components/PDFItensOrcamento/components/util";
import { UnidadeMedidaEnum } from "core/features/orcamento/typings";

export default function ItemTable({ item }: { item: OrcamentoCotacaoItem }) {
  return (
    <Flex
      px={4}
      h="60px"
      align="center"
      borderTop={`1px solid ${colors.gray10}`}
    >
      <Flex flex={4}>{item.nome}</Flex>
      <Flex flex={1}>
        {item.quantidade}
        {` `}
        {getUnidadeMedida(item?.unidadeMedidaId!)}
        {item?.quantidade! > 1
          ? `${item?.unidadeMedidaId === UnidadeMedidaEnum.Mes ? "es" : "s"}`
          : ""}
      </Flex>
      <Flex
        flex={1}
        flexDir="column"
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <Text>{formatMoney(item.valorUnitario)}</Text>
        <Text color={colors.red}>{item.indisponivel ? "Não tem" : null}</Text>
      </Flex>
      <Flex
        flex={1.5}
        justifyContent="flex-end"
        color={item.indisponivel ? colors.red : undefined}
      >
        {formatMoney(item.total)}
      </Flex>
    </Flex>
  );
}
